import React from 'react';

const EventList = () => {
    return (
        <div>
            Event List
        </div>
    );
};

export default EventList;